import type { saddleFilters, saddleType } from '@/types/saddle'
import axios from 'axios'

export default class {
  static async fetchSaddles({
    sessionId = undefined,
    filters = undefined,
  }: {
    sessionId?: string
    filters?: saddleFilters
  } = {}) {
    return axios.post<saddleType>('/Hardware/RetrieveSaddles', {
      sessionId: sessionId,
      ...filters,
    })
  }

  static async fetchAverageSaddle({
    sessionId = undefined,
  }: {
    sessionId?: string
  } = {}): Promise<saddleType> {
    const { data } = await this.fetchSaddles({
      sessionId: sessionId,
      filters: { FreeTextSearch: 'PRO Stealth', Width: 142 },
    })
    return data.Saddles[0] ?? undefined
  }
}
